import { exists } from 'src/app/functions/exists';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'exists',
  standalone: false
})
export class ExistsPipe implements PipeTransform {
  transform(value: any): boolean {
    return exists(value);
  }
}
